import React, {FC, RefObject} from 'react'
import {NotificationItem} from '../../../../app/@contexts'
import {FormatDateToCA, TruncateText} from '../../../../app/features'
import {Link} from 'react-router-dom'

interface NotificationTabPaneProps {
  items: NotificationItem[];
  scrollRef: RefObject<HTMLDivElement>;
}

const NotificationTabPane: FC<NotificationTabPaneProps> = ({items, scrollRef}) => (
  <div className="tab-pane fade show" id="kt_top_bar_notifications_2" role="tabpanel">
    <div className="scroll-y mh-325px px-3 pt-5" ref={scrollRef}>
      {items.map((item, index) => (
        <div className="row mb-5" key={index}>
          <div className="col-3">
            <span className="fs-7">{FormatDateToCA(item.created_at)}</span>
          </div>
          <div className="col-9">
            <div className="flex-grow-1">
              <Link to={`/${item.data.model_id}`}
                    className="text-gray-800 text-hover-primary fw-bolder fs-6">{TruncateText(item.data.message, 60)}</Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
)

export default NotificationTabPane